const NECESSARY_STATUS = 'Necessary'
const UNNECESSARY_STATUS = 'Unnecessary'
const ELIMINATED_STATUS = 'Eliminated'

export default {
  NECESSARY_STATUS,
  UNNECESSARY_STATUS,
  ELIMINATED_STATUS,
}
